import { ILocationAddress, LocationTypeRevamp } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export type TCreateBusinessEntityLocation = {
  locationTypes: LocationTypeRevamp[];
  address: ILocationAddress;
  locationName?: string;
  employeeCount?: number;
  isVirtualAddress?: boolean;
  startDate?: string | null;
  endDate?: string | null;
};

export const createBusinessEntityLocation = async (
  body: TCreateBusinessEntityLocation,
  businessEntityId: number
) => {
  const response = await fetcher(
    `business-entities/${businessEntityId}/locations`,
    {
      method: 'POST',
      body,
    }
  );

  return response;
};
